// sidebar nav links
export default {
   category1: [
     /* {
         "menu_title": "sidebar.dashboard",
         "menu_icon": "zmdi zmdi-view-dashboard",
         "type_multi": null,
         "rol" : ['administrador'],
         "child_routes": [
            {
               "menu_title": "sidebar.ecommerce",
               "new_item": false,
               "path": "/app/dashboard/ecommerce",
               "rol" : ['administrador']
            },
            {
               "menu_title": "Prueba",
               "new_item": true,
               "path": "/app/users/prueba",
               "rol" : ['administrador']
            }
         ]
      }*/
      {    
         "menu_title": "sidebar.dashboard",
         "menu_icon": "zmdi zmdi-view-dashboard",
         "type_multi": null,
         "rol" : ['supervisor','administrador','empleado'],
         "path": "/app/dashboard"
      }
   ],
    category2: [
      {
         "menu_title": "sidebar.rrhh",
         "menu_icon": "zmdi zmdi-account-box-mail",
         "type_multi": null,
         "ids":[1,2],
         "new_item": false,
         "rol" : ['administrador'],
         "child_routes": [
            {
               "menu_title": "sidebar.payslip",
               "new_item": false,
               "path": "/app/rrhh/payslip-management",
               "rol" : ['administrador']
            },
            {
               "menu_title": "sidebar.rrhh.params",
               "new_item": false,
               "path": "/app/rrhh/payslip-params-management",
               "rol" : ['administrador']
            }
         ]
      }
   ],
    category3: [
      {
         "menu_title": "sidebar.users",
         "menu_icon": "zmdi zmdi-accounts",
         "type_multi": null,
         "new_item": false,
         "rol" : ['supervisor','administrador'],
         "child_routes": [
            {
               "menu_title": "sidebar.userManagement",
               "new_item": false,
               "path": "/app/users/user-management",
               "rol" : ['supervisor','administrador']
           },
            {
               "menu_title": "Getión de Seguimiento",
               "new_item": false,
               "path": "/app/seguimiento/seguimiento-management",
               "rol" : ['supervisor','administrador']
          
            },
            {
               "menu_title": "Gestión de instalaciones",
               "new_item": false,
               "path": "/app/instalaciones/instalaciones-management",
               "rol" : ['administrador']
           }
         ]
         
      }
   ],
    category4: [
      {
         "menu_title": "sidebar.documents",
         "menu_icon": "zmdi zmdi-file-text",
         "type_multi": null,
         "new_item": false,
         "rol" : ['administrador'],
         "child_routes": [
            {
               "menu_title": "sidebar.documentManagement",
               "new_item": false,
               "path": "/app/documents/document-management",
               "rol" : ['administrador']
            }
         ]
      }
   ],
    category5: [
      {
         "menu_title": "sidebar.RRHHManagement",
         "menu_icon": "zmdi zmdi-shield-security",
         "type_multi": null,
         "new_item": true,
         "rol" : ['administrador','supervisor'],
         "ids":[1,2,233],
         "child_routes": [
            {
               "menu_title": "sidebar.RRHHCategories",
               "new_item": false,
               "path": "/app/prev-riesgo/documentos-categorias-management",
               "rol" : ['administrador','supervisor']
            },
            {
               "menu_title": "sidebar.RRHHDocuments",
               "new_item": false,
               "path": "/app/prev-riesgo/documentos-management",
               "rol" : ['administrador','supervisor']
            }
         ]
      }
   ],
   category6: [
      {    
         "menu_title": "Calendario",
         "menu_icon": "zmdi zmdi-calendar",
         "type_multi": null,
         "rol":["administrador"],
         "path": "/app/calendario",
         "new_item": true
      }
      
   ],         
   
   category7: [
      {
         "menu_title": "sidebar.control",
         "menu_icon": "zmdi zmdi-car-taxi",
         "type_multi": null,
         "new_item": false,
         "rol" : ['supervisor','administrador','empleado'],
         "ids":[1,2],
         "child_routes": [
            {
               "menu_title": "sidebar.controlManagement",
               "new_item": false,
               "path": "/app/control/control-management",
               "rol" : ['supervisor','administrador','empleado']
            }
         ]
      }
   ],
    category8: [
      {
         "menu_title": "Logs",
         "menu_icon": "zmdi zmdi-mouse",
         "type_multi": null,
         "rol" : ['administrador'],
         "ids":[1,2],
         "path": "/app/logs",
         "new_item": false
      }
   ]
   
}
